<template>
    <div class="row justify-content-center align-self-center w-100">
        <div class="col-md-8 text-secondary text-center">
            <div class="row">
                <div class="col-4">
                    <b-link href="chiffre-affaires/tableau-interactif">
                        <b-card class="shadow bg-primary" style="height: 150px">
                            <i
                                class="far fa-chart-line fa-fw fa-3x text-success"
                            ></i>
                            <h3 class="mt-3 text-white">
                                Chiffre d'affaires annuel
                            </h3>
                        </b-card>
                    </b-link>
                </div>
                <div class="col-4">
                    <b-link
                        href="chiffre-affaires/facturation-vs-reel/tableau-interactif"
                    >
                        <b-card class="shadow bg-primary" style="height: 150px">
                            <i
                                class="far fa-chart-pie-alt fa-fw fa-3x text-success"
                            ></i>
                            <h3 class="mt-3 text-white">Analyse de marge</h3>
                        </b-card>
                    </b-link>
                </div>
                <div class="col-4">
                    <b-link
                        href="tableaux-de-bord/time-sheets/controle-saisie-hebdo"
                    >
                        <b-card class="shadow bg-primary" style="height: 150px">
                            <i
                                class="far fa-stopwatch fa-fw fa-3x text-success"
                            ></i>
                            <h3 class="mt-3 text-white">
                                Contrôle de saisie des timesheets
                            </h3>
                        </b-card>
                    </b-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardHome',

    created() {
        this.$store.commit('reportingVM/RESET_SEARCH')
    },
}
</script>

<style scoped></style>
